const Mutations = Object.freeze({
	SET_PERMISSIONGROUPS: 'userProjectPermission/SET_PERMISSIONGROUPS',
	SET_USERPROJECTS: 'userProjectPermission/SET_USERPROJECTS',
	SET_USERPERMISSIONGROUP: 'userProjectPermission/SET_USERPERMISSIONGROUP',
	SET_USERPROJECTPERMISSION:
		'userProjectPermission/SET_USERPROJECTPERMISSION',
	SET_ALLPERMISSIONS: 'userProjectPermission/SET_ALLPERMISSIONS',
	SET_LOADING: 'userProjectPermission/SET_LOADING',
});
export const Actions = Object.freeze({
	LOAD: 'userProjectPermission/LOAD',
	LOAD_ALLPERMISSIONS: 'userProjectPermission/LOAD_ALLPERMISSIONS',
	LOAD_USERPROJECTS: 'userProjectPermission/LOAD_USERPROJECTS',
	LOAD_USERPERMISSIONGROUP: 'userProjectPermission/LOAD_USERPERMISSIONGROUP',
	LOAD_PERMISSIONGROUPS: 'userProjectPermission/LOAD_PERMISSIONGROUPS',
	LOAD_USERPROJECTPERMISSION:
		'userProjectPermission/LOAD_USERPROJECTPERMISSION',
	INSERT_USERPROJECTPERMISSION:
		'userProjectPermission/INSERT_USERPROJECTPERMISSION',
	DELETE_USERPROJECTPERMISSION:
		'userProjectPermission/DELETE_USERPROJECTPERMISSION',
});
export const Getters = Object.freeze({
	USERPROJECTS: 'userProjectPermission/USERPROJECTS',
	PERMISSIONGROUPS: 'userProjectPermission/PERMISSIONGROUPS',
	UNASSIGNEDPERMISSIONS: 'userProjectPermission/UNASSIGNEDPERMISSIONS',
	ASSIGNEDPERMISSIONS: 'userProjectPermission/ASSIGNEDPERMISSIONS',
	IS_LOADING: 'userProjectPermission/IS_LOADING',
});
import dataService from '../../../../../services/data/clientUserManagementService';
import { GeneralActions } from '../../../../actions';
export default {
	state: {
		permissionGroups: [],
		userProjects: [],
		permissions: [],
		userProjectPermissions: [],
		loading: false,
	},

	mutations: {
		[Mutations.SET_LOADING](state, item) {
			state.loading = item;
		},
		[Mutations.SET_PERMISSIONGROUPS](state, item) {
			state.permissionGroups = item;
		},
		[Mutations.SET_USERPROJECTS](state, item) {
			state.userProjects = item;
		},
		[Mutations.SET_USERPROJECTPERMISSION](state, item) {
			state.userProjectPermissions = item;
		},
		[Mutations.SET_ALLPERMISSIONS](state, item) {
			state.permissions = item;
		},
	},
	actions: {
		[Actions.LOAD_PERMISSIONGROUPS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getPermissionGroups()
					.then((resp) => {
						commit(Mutations.SET_PERMISSIONGROUPS, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
					});
			});
		},
		[Actions.LOAD_USERPROJECTS]({ commit, dispatch }, userId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.getAllUserProjects(userId)
					.then((resp) => {
						commit(Mutations.SET_USERPROJECTS, resp.data);
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_ALLPERMISSIONS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.getAllPermissions()
					.then((resp) => {
						commit(Mutations.SET_ALLPERMISSIONS, resp.data);
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_USERPROJECTPERMISSION](
			{ commit, dispatch },
			{ userId, projectId }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				if (!projectId) {
					resolve();
				} else {
					dataService
						.getAllUserProjectsPermissions(userId, projectId)
						.then((resp) => {
							commit(
								Mutations.SET_USERPROJECTPERMISSION,
								resp.data
							);
							commit(Mutations.SET_LOADING, false);
							dispatch(GeneralActions.LOADING, false);
							resolve();
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							dispatch(GeneralActions.LOADING, false);
							commit(Mutations.SET_LOADING, false);
							resolve();
						});
				}
			});
		},
		[Actions.LOAD]({ dispatch }, { userId, projectId }) {
			return Promise.all([
				dispatch(Actions.LOAD_ALLPERMISSIONS),
				dispatch(Actions.LOAD_USERPROJECTS, userId),
				dispatch(Actions.LOAD_PERMISSIONGROUPS),
				dispatch(Actions.LOAD_USERPROJECTPERMISSION, {
					userId: userId,
					projectId: projectId,
				}),
			]);
		},

		[Actions.INSERT_USERPROJECTPERMISSION](
			{ commit, dispatch },
			{ userId, projectId, permissions }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.postUserProjectPermissions(userId, projectId, permissions)
					.then(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.DELETE_USERPROJECTPERMISSION](
			{ commit, dispatch },
			{ userId, projectId, permissions }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.deleteUserProjectPermission(userId, projectId, permissions)
					.then(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.IS_LOADING]: (state) => {
			return JSON.parse(JSON.stringify(state.loading));
		},
		[Getters.PERMISSIONGROUPS]: (state) => {
			return JSON.parse(
				JSON.stringify(
					state.permissionGroups.sort((a, b) =>
						a.Name > b.Name ? 1 : -1
					)
				)
			);
		},
		[Getters.USERPROJECTS]: (state) => {
			return JSON.parse(
				JSON.stringify(
					state.userProjects.sort((a, b) =>
						a.ProjectName > b.ProjectName ? 1 : -1
					)
				)
			);
		},
		[Getters.ASSIGNEDPERMISSIONS]: (state) => {
			let result = [];
			state.permissions.forEach((p) => {
				let assigned = state.userProjectPermissions.find(
					(x) => x.PermissionId == p.PermissionId
				);
				if (assigned) result.push(p);
			});
			return result;
		},
		[Getters.UNASSIGNEDPERMISSIONS]: (state) => {
			let result = [];
			state.permissions.forEach((p) => {
				let assigned = state.userProjectPermissions.find(
					(x) => x.PermissionId == p.PermissionId
				);
				if (!assigned) result.push(p);
			});
			return result;
		},
	},
};
